module.exports = __webpack_public_path__ + "img/85.7.Chla.0ee455c8.png";